export default __webpack_public_path__ + "static/media/Blog2.97cfaf59.jpg";